import { pxToRem } from '../../utils';
var _a = [2, 3].map(function (v) { return pxToRem(v); }), _2px_asRem = _a[0], _3px_asRem = _a[1];
export default (function (siteVars) { return ({
    backgroundColor: siteVars.gray10,
    containerDivBorderRadius: _3px_asRem,
    containerDivBorderBottom: _2px_asRem + " solid transparent",
    containerDivBorderColor: 'transparent',
    containerDivColor: siteVars.bodyColor,
    containerDivFocusBorderColor: siteVars.brand,
    containerDivFocusBorderRadius: _3px_asRem + " " + _3px_asRem + " " + _2px_asRem + " " + _2px_asRem,
    editTextFlexBasis: '100px',
    listItemBackgroundColor: siteVars.white,
    listItemHighlightedBackgroundColor: siteVars.brand,
    listItemHighlightedTextColor: siteVars.white,
    listMaxHeight: '20rem',
    toggleButtonSize: pxToRem(30),
    width: pxToRem(356),
}); });
